export interface VerifyMediaProps {
  isVerifiable?: boolean
  verifiedArpMediaIDs?: number[]
  onVerify?: (arpIdToVerify: number) => void
}
